import {Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NotificationsService} from '@catcore/services';
import {EntitySchemaService} from '@catcore/services/entity-schema.service';
import {ResourceTargetsService} from '@catcore/types/services';
import {resolveEntityNameByResourceUri} from '@catcore/utils';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {ResourceFormTransactionEvent, ResourceTransactionEvent} from '@catfeatures/types';
import {NotImplementedYetComponent} from '@catuimodels/components/not-implemented-yet/not-implemented-yet.component';
import {ConfirmationService} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';

/**
 *
 */
@Component({
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.scss'],
})
export class ResourceComponent implements OnInit {

  jsonSchema: any = {};
  formData: any = {};

  @ViewChild('widgetContainer', {read: ViewContainerRef})
  widgetContainer: ViewContainerRef;

  private formComponent: ComponentRef<any>;
  private currentResourceRef: string;
  private currentResourceServiceSubscription;

  constructor(private route: ActivatedRoute,
              private resourceService: GenericResourceService,
              private schemaService: EntitySchemaService,
              private componentFactory: ComponentFactoryResolver,
              private confirmationService: ConfirmationService,
              private targetService: ResourceTargetsService,
              private notification: NotificationsService) {
  }

  private initForResource(resourceUri: string) {
    this.currentResourceRef = resourceUri;

    if (this.currentResourceServiceSubscription) {
      this.currentResourceServiceSubscription.unsubscribe();
    }

    if (this.formComponent) {
      this.formComponent.destroy();
    }

    const componentFactory = this.getComponentForResource(resourceUri);
    const service = this.resourceService.findServiceForResource(resourceUri);

    this.formComponent = this.widgetContainer.createComponent(componentFactory);

    this.currentResourceServiceSubscription = service
      .getCurrent()
      .subscribe((resourceData) => {
        const shouldBeInitialized = !isNullOrUndefined(resourceData) && this.formData.id !== resourceData.id;
        const shouldBeUpdated = !isNullOrUndefined(resourceData) && this.formData !== resourceData;

        if (shouldBeUpdated) {
          this.jsonSchema = this.schemaService.getForResourceUri(resourceUri);
          this.formData = resourceData;

          this.formComponent.instance.resourceUri = resourceUri;
          this.formComponent.instance.formData = this.formData;
          this.formComponent.instance.schema = this.jsonSchema;
        }

        if (shouldBeInitialized) {
          if (!isNullOrUndefined(this.formComponent.instance.onFormSubmit)) {
            this.formComponent.instance.onFormSubmit
              .subscribe((event: ResourceFormTransactionEvent) => {
                this.onFormSubmit(event);
              });
          }
          if (!isNullOrUndefined(this.formComponent.instance.deleteResource)) {
            this.formComponent.instance.deleteResource
              .subscribe((item: ResourceTransactionEvent) => this.deleteResource(item));
          }

        }

      });
    service.load();
  }

  ngOnInit() {

    this.route.queryParamMap.subscribe((queryParams) => {
      const resourceUri = queryParams.get('resource');
      if (resourceUri !== this.currentResourceRef) {
        this.initForResource(resourceUri);
      }
    });
  }

  onFormSubmit(formResult: ResourceFormTransactionEvent) {
    const service = this.resourceService.findServiceForResource(formResult.resourceUri);

    const subscription = service.save(formResult.formData)
      .subscribe((result) => {
        this.formComponent.instance.formData = result;
        this.notification.success('Update successfully', 'The update process was successfully.');
        formResult.success(result);
        subscription.unsubscribe();
      });
  }

  deleteResource(item: ResourceTransactionEvent) {
    this.confirmationService.confirm({
      message: 'Do you really want to delete this element?',
      accept: () => {
        const service = this.resourceService.findServiceForResource(item.ref);
        const subscription = service
          .delete()
          .subscribe(() => {
            this.notification.success('Item deleted', 'The item was successfully removed.');
            item.success(null);
            subscription.unsubscribe();
          });
      },
    });
  }

  private getComponentForResource(resourceUri: string): ComponentFactory<any> {
    const entityName = resolveEntityNameByResourceUri(resourceUri);
    const modelComponents = this.targetService.getMap();
    let component = modelComponents.get(entityName);

    if (!component) {
      component = NotImplementedYetComponent;
    }

    return this.componentFactory.resolveComponentFactory(component);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/core/components/resource/resource.component.ts